<template>
    <v-dialog persistent v-model="ui.display">
        <v-card v-if="data!=null">
            <v-toolbar dense color="primary" dark align="center">
                <v-row>                        
                    <v-col cols="5" align="left">
                        <v-toolbar-title>Permanenza dati grezzi</v-toolbar-title>
                    </v-col>
                    <v-col cols="2">
                        <v-btn small light @click="save">
                            <v-icon color="success">mdi-floppy</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="5" align="right">
                        <v-btn small light @click="close">
                            <v-icon color="error">mdi-close</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-toolbar>
            <v-container>
                <v-row>
                    <v-col cols="4">
                        <v-text-field type="number" v-model="data.quantity" min="0" label="Valore"/>
                    </v-col>
                    <v-col cols="1" />
                    <v-col cols="6">
                        <v-select :items="um" v-model="data.um" label="Unità di misura" />
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    name:'DialogTimeoutDatiGrezzi',
    data(){
        return{
            data : null,
            NETWORK : null,
            ui : {
                display : false
            },
            um : [
                { text: 'Minuti', value: 0 },
                { text: 'Ore', value: 1 },
                { text: 'Giorni', value: 2},
                { text: 'Settimane', value: 3}
            ]
        }
    },
    mounted(){
        this.NETWORK = this.$store.state.Network;
    },
    methods : {
        close(){
            this.ui.display = false;
            this.data = null;
        },
        open(){
            const that = this;
            const request = {
                controller: 'quickconnext',
                endpoint : 'connext',
                response: { parse: false },
                    body: {
                        action: 'getrawdatalifespan',
                        token: localStorage.user_token
                },
                method: 'POST',
                on: {
                    load: function (response) { 
                        try{
                            that.data = JSON.parse(response);
                        }catch{
                            that.data = { quantity:0, um:0 }
                        } 
                        that.ui.display = true;
                    }
                }
            };
            this.NETWORK.AjaxRequest(request);
        },
        save(){
            try{
                if(this.data.quantity == null){ throw 0; }
                const quantity = Number(this.data.quantity);
                if(!Number.isInteger(quantity) || quantity < 0){ throw 0; }
                if(!isFinite(parseInt(quantity, 10)) ){ throw 0; }

                if(this.data.um == null){ throw 1; }
                const um = Number(this.data.um);
                if(!isFinite(um) ){ throw 1; }
                let found = false;
                for(let i=0; i<this.um.length; i++){
                    const i_um = this.um[i];
                    if(i_um.value == um){
                        found = true;
                        break;
                    }
                }
                if(!found){ throw 1; }
                
                const that = this;
                const request = {
                    controller: 'quickconnext',
                    endpoint : 'connext',
                    response: { parse: false },
                        body: {
                            action: 'setrawdatalifespan',
                            quantity : quantity,
                            um : um,
                            token: localStorage.user_token
                    },
                    method: 'PUT',
                    on: {
                        load: function () { 
                            that.close();
                        }
                    }
                };
                this.NETWORK.AjaxRequest(request);

            }catch(error){
                switch(error){
                    case 0:
                        alert('Il parametro quantità deve essere un numero intero positivo');
                        break;
                    case 1:
                        alert('Selezionare un\'unità di misura');
                        break;
                }
            }
            
            
        }
    }
}
</script>